import PicsumLinkGenerator from "./picsum";

import { Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

import "./Slideshow.css";
import useIsMobile from "./IsMobile";

const width = window.innerWidth;

const fadeImages = [
  {
    url: `${PicsumLinkGenerator(1920, width)}`,
    caption: "Slide 1",
    alt: "Image 1",
  },
  {
    url: `${PicsumLinkGenerator(1920, width)}`,
    caption: "Slide 2",
    alt: "image 2",
  },
  {
    url: `${PicsumLinkGenerator(1920, width)}`,
    caption: "Slide 3",
    alt: "image 3",
  },
];

const Slideshow = () => {
  const isMobile = useIsMobile();

  return (
    <></>

    // <div
    //   id="Slideshow-container"
    //   className={`${isMobile ? "mobile" : "desktop"}`}
    // >
    //   <Fade>
    //     {fadeImages.map((fadeImage, index) => (
    //       <div key={index} className="slide-container">
    //         <img src={fadeImage.url} alt={fadeImage.alt} />
    //         {/* <h2>{fadeImage.caption}</h2> */}
    //       </div>
    //     ))}
    //   </Fade>
    // </div>
  );
};

export default Slideshow;
